import { useEffect } from "react";
import PropTypes from "prop-types";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { setGorgiasChatVisibility } from "@helpers/gorgias";
import { cn } from "@helpers/general";

import "./slideOutMenu/styles.scss";

function SlideOutMenu({
  align,
  headerContent,
  isSlideoutOpen,
  toggleSlideout,
  customClass,
  children,
}) {
  useEffect(() => {
    setGorgiasChatVisibility(!isSlideoutOpen);
  }, [isSlideoutOpen]);

  return (
    <>
      <div
        className={cn(
          "slideout_container",
          isSlideoutOpen ? "slideout_container--isOpen" : "slideout_container--isClosed"
        )}
        onClick={toggleSlideout}
        aria-hidden="true"
      />
      <div
        className={cn(
          "flex flex-col slideout",
          `slideout--${align}`,
          isSlideoutOpen ? "slideout--isOpen" : `slideout-${align}--isClose`,
          customClass
        )}
      >
        {headerContent}
        {children}
      </div>
    </>
  );
}

SlideOutMenu.propTypes = {
  align: PropTypes.oneOf(["left", "right", "bottom"]),
  headerContent: PropTypes.node,
  isSlideoutOpen: PropTypes.bool.isRequired,
  toggleSlideout: PropTypes.func,
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.element]),
};

export default withALErrorBoundary({
  name: "SlideOutMenu",
  priority: "P3",
})(SlideOutMenu);
